<template>
<div>

	<!-- Begin Title Bar -->
	<v-toolbar tile elevation="2">
		<v-toolbar-title>{{ $t('nav.createNewOrder') }}</v-toolbar-title>

		<v-spacer></v-spacer>

		<v-btn icon v-if="initializationDone" @click="$router.go(-1)">
			<v-icon class="color-green">mdi-arrow-left</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="refresh">
			<v-icon class="color-green">mdi-refresh</v-icon>
		</v-btn>
		<v-btn icon v-if="initializationDone" @click="showHelp = true">
			<v-icon class="color-green">mdi-help-circle</v-icon>
		</v-btn>

	</v-toolbar>
	<!-- End Title Bar -->

	<Preloader v-if="!initializationDone" :text="$t('common.phrase.loading')"></Preloader>


	<v-container v-if="initializationDone">

		<v-sheet elevation="2" class="pa-5 my-4">

			<NewOrderForm allowaddtoken allowsetallowance :tokenselection="tokenSelection">
			</NewOrderForm>

		</v-sheet>

		<!-- Begin Help -->
		<v-bottom-sheet v-model="showHelp">

			<v-card tile>

				<!--Modal Title -->
				<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
					<v-toolbar-title><v-icon>mdi-help-circle</v-icon> {{ $t('nav.help') }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="showHelp = false">
						<v-icon>mdi-window-close</v-icon>
					</v-btn>
				</v-toolbar>

				<!-- Modal Contents -->
				<v-card-text class="py-5 px-3" style="max-height: 400px; overflow-y: scroll;">
					<CreateOrderHelp class="mb-2"></CreateOrderHelp>
				</v-card-text>

			</v-card>

    </v-bottom-sheet>
    <!-- End Help -->

	</v-container>



</div>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import NewOrderForm from "@/components/NewOrderForm"
import CreateOrderHelp from "@/components/help/CreateOrderHelp"

export default {
	name: 'NewOrder',
	components: {
		Preloader,
		NewOrderForm,
		CreateOrderHelp,
	},
	data () {
		return {
			initializationDone: false,
			showHelp: false,
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			networkConfig: 'getNetworkConfig',
		}),
		tokenSelection: function () {
			const selection = {}
			if (this.$route.params.makerAssetAddress) {
				selection.makerAssetAddress = this.$route.params.makerAssetAddress
			}
			if (this.$route.params.takerAssetAddress) {
				selection.takerAssetAddress = this.$route.params.takerAssetAddress
			}
			return selection
		}
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),

		/* ------------------------------------------------------ */
		async init () {
			this.initializationDone = false
			try {
				await this.loadNetwork()
				// console.log(this.network)
				await this.loadTokenInfo()
				// console.log(this.tokenInfo)
				await this.loadAccount()
				// console.log(this.account)
				this.initializationDone = true
			} catch (err) {
				console.log(err)
				this.$emit("errorNotification", this.$t('common.err.generic'))
			}
		},
		async refresh() {
			await this.init()
		},
	},
	created () {
		this.init()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
